import { render, staticRenderFns } from "./NuevaTarimaModalComponent.vue?vue&type=template&id=4843ac2b&"
import script from "./NuevaTarimaModalComponent.vue?vue&type=script&lang=js&"
export * from "./NuevaTarimaModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports